import React, { Component } from 'react';
import { header } from 'constants/table';
import { RowItemCapNhatNguoiDungXLD } from './datatable/list';
import { Input, Text } from 'components/tt-forms/common';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import {
  DropDownMulipleUse
} from 'components/tt-forms';
import { ShowIf } from 'components/utils';
import { MasterLayout } from 'layout';
import { Danhmuc, GiaiQuyetDonThu } from 'api';
import { get, isEmpty } from 'lodash'
import { DataTableMultipleSelect } from 'modules/thanh-tra/datatable';
import classnames from 'classnames';
import { Toastr } from 'modules/toastr';

class DanhSachDonTheoCongChuc extends Component {
  constructor (props) {
    super(props);
    this.state = {
      dataTable: [],
      tenEmail: '',
      nguoiDungThayThe: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      dataNguoiDungThayThe: [],
      congChucInfo: {},
      listCheckedId: [],
      isOpen: false,
      loadingTable: false,
      checkAll: false,
      searchLoading: false
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  openDialog() {
    this.setState({
      isOpen: true
    })
  }

  closeDialog() {
    this.setState({
      isOpen: false
    })
  }

  // Validate Form
  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size
      }
    },() => {
      this.getListData();
    })
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    },() => {
      this.getListData();
    })
  }

  // Get thông tin công chức
  getCongChucInfo() {
    this.setState({
      loadingTable: true
    })
    const params = {
      email: this.state.tenEmail || ''
    }
    GiaiQuyetDonThu.actions.getCongChucByEmail.request(params).then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          congChucInfo: {
            ...data
          }
        })
      } else {
        this.setState({
          congChucInfo: {},
          dataTable: []
        })
      }
    }).catch(error => {}).finally(() => {
      this.setState({
        listCheckedId: [],
        checkAll: false,
      })
      this.getListData()
    })
  }

  async handleSearch (e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      await this.getCongChucInfo();
    }
  }

  // Get dữ liệu table
  getListData() {
    this.setState({
      loadingTable: true
    })
    const params = {
      congChucId: (this.state.congChucInfo && this.state.congChucInfo.id) || '',
      donViId: (this.state.congChucInfo && this.state.congChucInfo.donViId) || '',
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngayTiepNhan,desc'
    }
    Danhmuc.actions.getDanhSachXuLy.request(null, params).then(res => {
      const pageData = get(res, 'data.page');
      const data = get(res, 'data._embedded.dons', []);
      this.setState({
        dataTable: data,
        pageData
      })
    }).catch(error => {}).finally(() => {
      setTimeout(() => {
        this.setState({
          loadingTable: false
        })
      }, 1500);
    })
  }

  // Get danh sách công chức cùng vai trò
  getListCongChucThayDoi() {
    const { congChucInfo } = this.state;
    let params = {
      vaiTro: get(congChucInfo, 'loaiVaiTro'),
      coQuanQuanLyId: get(congChucInfo, 'coQuanQuanLyId'),
      congChucHienTaiId: get(congChucInfo, 'id')
    }
    GiaiQuyetDonThu.actions.getCongChuc.request(params).then(res => {
      if(res.data._embedded) {
        this.setState({
          dataNguoiDungThayThe: res.data._embedded.congChucs
        })
      }
    })
  }

  // Chọn một đơn
  async handleSelectedDoiTuong(item) {
    item.selected = !item.selected;
    const donIdSelect = item.donId;
    let { listCheckedId } = this.state;
    if (item.selected) {
      listCheckedId.push(donIdSelect);
    } else {
      listCheckedId = listCheckedId.filter(item => item !== donIdSelect);
    }
    this.setState({
      listCheckedId
    })
  }

  // Chọn tất cả đơn
  handleSelectedAll() {
    const itemCheck = !this.state.checkAll;
    let { listCheckedId, dataTable } = this.state;
    if (itemCheck) {
      listCheckedId = dataTable.map(item => item.donId)
    } else {
      listCheckedId = []
    }
    dataTable = dataTable.map(item => {
      return {
        ...item,
        selected: itemCheck
      }
    })

    this.setState({
      checkAll: itemCheck,
      dataTable,
      listCheckedId
    });
  }

  // Handle xử lý
  handleSwitch() {
    if (!isEmpty(this.state.congChucInfo) && !isEmpty(this.state.listCheckedId)) {
      this.getListCongChucThayDoi()
      this.openDialog()
    }
  }

  updateUser() {
    const { congChucInfo, nguoiDungThayThe, listCheckedId } = this.state;
    this.setState({
      buttonLoading: true
    })
    const params = {
      congChucId: congChucInfo.id,
      donIds: listCheckedId,
      toCongChucId: nguoiDungThayThe ? Number(nguoiDungThayThe) : undefined
    }
    Danhmuc.actions.switchCongChuc.request(null, params).then(res => {
      this.getListData();
      this.setState({
        listCheckedId: []
      })
    }).catch(error => {
      Toastr('Lỗi hệ thống', 'error');
    }).finally(() => {
      this.setState({
        nguoiDungThayThe: '',
        buttonLoading: false
      })
      this.closeDialog();
    })
  }

  render () {
    const { congChucInfo, listCheckedId, searchLoading, dataNguoiDungThayThe } = this.state;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Thay đổi người đang xử lý và giải quyết đơn</p>
            </div>
          </div>
          <div className="bottom-content">
            <form className="" onSubmit={this.handleSearch.bind(this)}>
              <div className='row pt20 pl25 pr25 pb5'>
                <Input className='col-50' require bindValidator={this} channel='formTaoDon' value={this.state.tenEmail} onChange={this.onChange.bind(this, 'tenEmail')} name='tenEmail' label='Tên email người dùng' placeholder='Nhập email người dùng...'/>
                <div className='col-25 mt22'>
                  <button type="submit" className={`pt-button btn-green tt-search ${this.state.loadingTable ? 'btn-loading-inline' : ''}`}>Tìm kiếm</button>
                </div>
              </div>
            </form>
            <div className="line-border"/>
            <div className="button-wrap-container">
              <Link
                className={classnames('btn-action btn-move action-todo mr0', {
                  'btn-disable-tttp': isEmpty(listCheckedId),
                  'btn-loading-inline': searchLoading
                })}
                onClick={ this.handleSwitch.bind(this)}
                ><span>Xử lý</span></Link>
            </div>
            <DataTableMultipleSelect
              header={header.categoryGroup.capNhatNguoiDungXLD}
              dataList={this.state.dataTable}
              hideButtonExport
              pageData={this.state.pageData}
              parent={this}
              onDisableCheck={isEmpty(this.state.dataTable)}
              tableLoading={this.state.loadingTable}
              onCheck={this.handleSelectedAll.bind(this)}
              selectAllStatus={this.state.checkAll}
            >
              <RowItemCapNhatNguoiDungXLD/>
            </DataTableMultipleSelect>
            <Dialog
              isOpen={this.state.isOpen}
              onClose={this.closeDialog.bind(this)}
              title="Xác nhận"
              className="panel-popup category">
              <div className="pt-dialog-body">
                <Text className="col-50" label="Người dùng hiện tại:" value={get(congChucInfo, 'hoVaTen')}/>
                <Text className="col-50" label="Vai trò:" value={get(congChucInfo, 'tenVaiTro')}/>
                <ShowIf condition={isEmpty(dataNguoiDungThayThe)}>
                  <p className='txt-center text-13 txt-bold col-100 mb18'>Không có tài khoản cùng vai trò để thay thế</p>
                </ShowIf>
                <ShowIf condition={!isEmpty(dataNguoiDungThayThe)}>
                  <DropDownMulipleUse className="col-50" label="Người dùng thay thế" channel='formCapNhat' require bindValidator={this} selectedValue={this.state.nguoiDungThayThe} onChange={this.onChange.bind(this, 'nguoiDungThayThe')} name='nguoiDungThayThe' data={this.state.dataNguoiDungThayThe} keyName='congChucId' valueName='hoVaTen'/>
                </ShowIf>
              </div>
              <div className="pt-dialog-footer">
                <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <ShowIf condition={!isEmpty(dataNguoiDungThayThe)}>
                  <Link className={`btn-action btn-green ${this.state.buttonLoading ? "btn-loading-inline" : ""}`} onClick={this.updateUser.bind(this)}>
                    <span>Đồng ý</span>
                  </Link>
                </ShowIf>
              </div>
            </Dialog>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

DanhSachDonTheoCongChuc.defaultProps={
  validators: {
    formTaoDon: [],
    formCapNhat: []
  }
}

export default DanhSachDonTheoCongChuc;



// WEBPACK FOOTER //
// ./src/components/modules/category/DanhSachDonTheoCongChuc.jsx